const CORRELATION_ID_KEY = 'correlation_id';

function generateUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID (very old browsers, some test runners).
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

/**
 * Returns a stable correlation ID for the current page session (browser tab).
 * Persisted in sessionStorage so it survives in-tab navigations and reloads,
 * and is reset when the tab is closed.
 *
 * Sent on every API request as `X-Correlation-ID` and registered as Datadog RUM
 * global context, so a single ID ties FE RUM events to BE logs for one user session.
 */
export function getCorrelationId(): string {
  if (typeof sessionStorage === 'undefined') {
    return generateUuid();
  }

  const existing = sessionStorage.getItem(CORRELATION_ID_KEY);
  if (existing) return existing;

  const next = generateUuid();
  sessionStorage.setItem(CORRELATION_ID_KEY, next);
  return next;
}
